import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import {
  getSeoCanonical,
  getSeoTitle,
  getSeoDescription,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { appLoaded } from '../../actions/app';
import { Props } from './App';
import { AppState } from '../../types/store';
import { getCurrentItem } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';

type StateProps = Pick<
  Props,
  'pageTitle' | 'pageDescription' | 'seoCanonical' | 'environment' | 'deviation'
>;
type DispatchProps = Pick<Props, 'appLoaded'>;
type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  pageTitle: getSeoTitle(state),
  pageDescription: getSeoDescription(state),
  seoCanonical: getSeoCanonical(state),
  environment: state.environment.type,
  deviation: getCurrentItem(state as any),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  appLoaded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
